module.exports = __webpack_public_path__ + "static/media/lastfm.3552d352.svg";